export type Language = 'pt' | 'en'

export type NavLink = {
  to: string
  label: string
}

export const navLinks: NavLink[] = [
  { to: '/', label: 'navbar.start' },
  { to: '/news', label: 'navbar.news' },
  { to: '/research', label: 'navbar.research' },
  { to: '/projects', label: 'navbar.projects' },
  { to: '/laboratory', label: 'navbar.laboratory' },
  { to: '/postgraduate', label: 'navbar.postgraduate' },
  { to: '/opportunities', label: 'navbar.opportunities' }
]
